/**************************************************
 * Nombre:       Home_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../../../App";
import img_fondo from '../../../Recursos/fondo_portada.svg'
import {scrolearAComponente} from "../../../Utilidades/scrolearAComponente";
import {useNavigate} from "react-router";
import Tarjeta_Black from "../../Tarjetas/Tarjeta_Black";


const Home_Portada = () => {
    const {sCell, masSM, esSafari} = useResponsive()
    const cData = useContext(contexApp)
    const navigate = useNavigate();
    const [video, setVideo] = useState('')
    const [bannerBlack, setBannerBlack] = useState(false)

    useEffect(() => {

        setVideo(cData.actColeccion?.video)
        if (cData.configuraciones?.black === 'Si') {
            setBannerBlack(true)
        } else {
            setBannerBlack(false)
        }

    }, [cData]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <video width={'100%'} height={630}
                   style={{
                       objectFit: 'cover',
                       zIndex: 1,
                       backgroundImage: `url(${img_fondo})`,
                       backgroundPosition: 'center',
                       backgroundSize: 'cover'
                   }}
                   id="background-video" autoPlay loop muted poster={cData.actColeccion.img}>
                {video &&
                    <source src={video} type="video/mp4"/>
                }
            </video>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    marginTop: -80.5,
                    zIndex: 2,
                    background: `linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0.00) 20.46%), linear-gradient(90deg, rgba(0, 0, 0, 0.28) 5.89%, rgba(0, 0, 0, 0.00) 50.65%)`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    minHeight: 642
                }}

            >
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 4, md: 3}}
                    sx={{maxWidth: '1400px', px: 7}}
                >


                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{mt: sCell ? 54 : 32, justifyContent: sCell ? 'center' : 'left'}}>
                        <Typography sx={{color: '#fff', fontSize: 20, lineHeight: 1.1}}>COLECCIÓN</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{mt: -1, justifyContent: sCell ? 'center' : 'left'}}>
                        <Typography sx={{
                            color: '#fff',
                            fontFamily: 'Dm Serif Display',
                            fontSize: !masSM ? 64 : 72,
                            lineHeight: 1.1,
                            textAlign: 'center'
                        }}>{cData?.actColeccion?.nombre}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{mt: 6, mb: sCell ? 3 : 26, justifyContent: sCell ? 'center' : 'left'}}>
                        <Button
                            onClick={() => sCell || esSafari() ? navigate('/DetalleCol/' + cData.actColeccion.id) : scrolearAComponente('pasarela')}
                            sx={{
                                backgroundColor: '#ffffff20',
                                border: 1,
                                borderColor: '#fff',
                                backdropFilter: 'blur(2px)',
                                boxShadow: 0
                            }}>{sCell || esSafari() ? 'Ver Colección' : 'Ver Pasarela'}</Button>
                    </Grid>


                </Grid>

                {bannerBlack &&
                    <Grid container size={{xs: 12, sm: 8, md: 9}}
                          sx={{justifyContent: 'flex-start', mt: sCell ? -62 : 24}}>
                        <Tarjeta_Black/>
                    </Grid>
                }


            </Grid>

        </Grid>

    )

}
export default Home_Portada